import { Http, Headers, URLSearchParams } from "@angular/http";
import 'rxjs/add/operator/toPromise';
import { environment } from "../../environments/environment";
import { AppService } from "../app.service";
var DeviceBoardService = (function () {
    function DeviceBoardService(http, appService) {
        this.http = http;
        this.appService = appService;
        this.apiUrl = environment.apiUrl;
        this.jwt = appService.getJwt();
    }
    DeviceBoardService.prototype.getDeviceBoardList = function (filterParams) {
        var url = this.apiUrl + 'api/cms/device-board/list';
        var headers = new Headers();
        headers.append('X-Authorization', 'Bearer ' + this.jwt);
        headers.append('Content-Type', 'application/json');
        var params = new URLSearchParams();
        params.append("page", filterParams.page);
        params.append("size", filterParams.size);
        var body = JSON.stringify({});
        return this.http.post(url, body, { headers: headers, params: params })
            .toPromise()
            .then(function (res) { return res.json(); })
            .then(function (resJson) { return resJson; });
    };
    DeviceBoardService.prototype.editDeviceBoard = function (data) {
        var url = this.apiUrl + 'api/cms/device-board/edit';
        var headers = new Headers();
        headers.append('X-Authorization', 'Bearer ' + this.jwt);
        headers.append('Content-Type', 'application/json');
        var body = JSON.stringify(data);
        return this.http.post(url, body, { headers: headers })
            .toPromise()
            .then(function (res) { return res.json(); })
            .then(function (resJson) { return resJson; });
    };
    return DeviceBoardService;
}());
export { DeviceBoardService };



// WEBPACK FOOTER //
// /build/client-cms/src/app/device-board/device-board.service.ts.pre-build-optimizer.js